import AlertChangeBrowser from './AlertChangeBrowser'

export default AlertChangeBrowser
